// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'
import './directives'

// Global Components
import Loading from '@/components/Loading'
import Layout from '@/layouts/Layout'
import CategoryLayout from '@/layouts/CategoryLayout'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true,
})

Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(VueGtag, {config: {id: 'G-58N8VRFBR3'}}, router)

// Global Components
Vue.component('loading', Loading)
Vue.component('layout', Layout)
Vue.component('category-layout', CategoryLayout)

// loads the Icon plugin
UIkit.use(Icons)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({ el: '#app', router, store, components: { App }, template: '<App/>' })



// WEBPACK FOOTER //
// ./src/main.js